package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.firebase.data.mappers.SerializableMappers
import com.exura.features.plandefinition.data.remote.dto.collection.CollectionDto
import com.exura.features.plandefinition.domain.model.collection.Collection
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Mapper for converting between Collection domain model and DTO.
 * Implements SerializableMappers for Firebase storage compatibility.
 */
class CollectionMappers : SerializableMappers<Collection, CollectionDto> {
    override fun toDto(model: Collection): CollectionDto = CollectionDto(
        name = model.name,
        description = model.description,
        relativeDay = model.relativeDay,
        durationInDays = model.durationInDays(),
        imageUrl = model.imageUrl,
    )

    override fun toDomain(dto: CollectionDto, collection: CollectionReference?, id: String?): Collection = Collection(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        name = dto.name,
        description = dto.description,
        relativeDay = dto.relativeDay,
        // Series will be loaded separately
        series = emptyList(),
        imageUrl = dto.imageUrl,
    )
}
